import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback({ setUser }) {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution using ref
    if (hasProcessed.current) {
      console.log('AuthCallback: Already processed, skipping');
      return;
    }
    hasProcessed.current = true;

    const processSession = async () => {
      // Extract session_id from URL fragment BEFORE clearing
      const hash = window.location.hash;
      console.log('AuthCallback: Processing hash:', hash);
      
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');
      console.log('AuthCallback: Session ID found:', sessionId ? 'yes' : 'no');

      // Clear the hash immediately to prevent reuse on refresh
      window.history.replaceState(null, '', window.location.pathname);

      if (!sessionId) {
        console.error('AuthCallback: No session ID found in URL');
        toast.error('No session ID found');
        navigate('/');
        return;
      }

      try {
        console.log('AuthCallback: Exchanging session_id with backend...');
        
        // Exchange session_id for session_token
        const response = await axios.post(`${API}/auth/session`, {
          session_id: sessionId
        }, {
          withCredentials: true
        });

        const { user } = response.data;
        console.log('AuthCallback: Auth successful for:', user?.email);

        // Update app-wide user state - THIS IS CRITICAL
        if (setUser) {
          setUser(user);
        }

        // Check for stored redirect path (from memorial flow or other)
        const intendedPath = sessionStorage.getItem('authRedirectPath') || '/home';
        sessionStorage.removeItem('authRedirectPath');

        toast.success(`Welcome, ${user?.name?.split(' ')[0] || 'User'}!`);

        // Navigate to intended destination with user data
        navigate(intendedPath, { 
          state: { user },
          replace: true 
        });
      } catch (error) {
        console.error('AuthCallback: Error:', error);
        console.error('AuthCallback: Error response:', error.response?.data);
        toast.error('Authentication failed. Please try again.');
        navigate('/');
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent mb-4"></div>
        <p className="text-lg font-sans text-foreground-muted">Authenticating...</p>
      </div>
    </div>
  );
}